import { theme } from 'antd';

export const darkTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    // screenXSMin: '400px',
    // screenSM: '500px',
    // screenMD: '768px',
    // screenLG: '1024px',
    // screenXL: 1500,
    screenXXLMin: 2000,
    screenXXL: 2100,

    colorPrimary: '#3390ec', // ← Telegram синий
    colorSuccess: '#03ba7a',
    colorError: '#f6465d',
    colorWarning: '#f0b90b',
    colorInfo: '#6495ed',

    colorTextBase: '#eaecef',
    colorTextSecondary: '#848e9c',
    colorTextPlaceholder: '#5e6673',

    colorBgBase: '#181a1e',
    colorBgContainer: '#1e2329',
    colorBorder: '#2b3139',
    colorSplit: '#2b3139',

    fontFamily: `'Roboto', 'Inter', sans-serif`,
  },

  components: {
    Layout: {
      headerBg: '#1e2329',
      bodyBg: '#181a1e',
      footerBg: '#1e2329',
      headerColor: '#eaecef',
      siderBg: '#1e2329',
      triggerBg: '#1e2329',
      triggerColor: '#eaecef',
      triggerHoverBg: '#2c3238',
    },

    Menu: {
      itemBg: '#1e2329',
      itemColor: '#eaecef',
      itemHoverBg: '#2c3238',
      itemHoverColor: '#3390ec',
      itemSelectedColor: '#3390ec',
      itemSelectedBg: '#2c3238',
    },

    Button: {
      colorPrimary: '#3390ec',
      colorPrimaryHover: '#4fa7ff',
      colorPrimaryActive: '#2a75cc',
      defaultBg: '#1e2329',
      defaultHoverBg: '#2c3238',
    },

    Input: {
      colorBgContainer: '#1e2329',
      colorText: '#eaecef',
      colorTextPlaceholder: '#5e6673',
      colorBorder: '#2b3139',
      activeShadow: '0 0 0 2px rgba(51, 144, 236, 0.2)',
    },

    Card: {
      colorBgContainer: '#1e2329',
      colorText: '#eaecef',
      colorBorder: '#2b3139',
    },

    Drawer: {
      colorBgElevated: '#1e2329',
      headerBg: '#1e2329',
      footerBg: '#1e2329',
      colorText: '#eaecef',
      colorTextHeading: '#eaecef',
      colorIcon: '#848e9c',
    },

    Table: {
      colorBgContainer: '#1e2329',
      headerBg: '#1e2329',
      headerColor: '#848e9c',
      colorText: '#eaecef',
      rowHoverBg: '#2c3238',
      borderColor: '#2b3139',
    },

    Tooltip: {
      colorBgSpotlight: '#2c3238',
      colorTextLightSolid: '#ffffff',
    },

    Select: {
      colorBgContainer: '#1e2329',
      colorText: '#eaecef',
      optionSelectedColor: '#3390ec',
      optionSelectedBg: '#2c3238',
    },

    Pagination: {
      itemBg: '#1e2329',
      itemLinkBg: '#1e2329',
      colorText: '#eaecef',
      colorPrimary: '#3390ec',
    },

    Tabs: {
      itemColor: '#eaecef',
      itemHoverColor: '#3390ec',
      itemSelectedColor: '#3390ec',
      inkBarColor: '#3390ec',
    },

    Alert: {
      colorInfoBg: '#2c3238',
      colorSuccessBg: '#153f35',
      colorWarningBg: '#4f4309',
      colorErrorBg: '#51212a',
      colorText: '#eaecef',
    },

    Collapse: {
      headerBg: '#1e2329',
      contentBg: '#181a1e',
    },

    Divider: {
      colorSplit: '#2b3139',
    },

    Switch: {
      colorPrimary: '#3390ec',
      colorBgContainer: '#2b3139',
      handleBg: '#ffffff',
    },

    Steps: {
      colorPrimary: '#3390ec',
      colorText: '#eaecef',
    },

    Tag: {
      colorBgContainer: '#2c3238',
      colorText: '#eaecef',
    },

    Progress: {
      remainingColor: '#2b3139',
    },

    Slider: {
      trackBg: '#3390ec',
      railBg: '#2b3139',
    },
  },
};
